import { Injectable } from '@angular/core';

import { Observable, ReplaySubject, Subject, Subscription } from 'rxjs';

import { QuestionRecord } from '../model/question-record';
import { Question, QuestionResponse } from '../model/question';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { UtilService } from './util.service';


@Injectable({
  providedIn: 'root'
})
export class QuestionsService {
  questionsList: Question[] = [];
  totalQuestions: number = 0;
  questionRecords: QuestionRecord[] = [];
  selectedQuestionNumber: number = 0;
  temporarySelectedOption: string[] = [];
  private attemptedQuestionCount = 0;
  attemptedQuestionCount$ = new ReplaySubject<number>(1);
  selectedQuestionNumber$: ReplaySubject<number> = new ReplaySubject<number>();
  changeQuestionRecord$: Subject<void> = new Subject<void>();
  selectedQuestionNumberSubscription$: Subscription;
  

  constructor ( 
    private http: HttpClient,
    private utilService: UtilService
  ) {
    this.onStartup();
  }

  onStartup(): void {
    this.selectedQuestionNumberSubscription$ = this.selectedQuestionNumber$.subscribe({
      next: (value) => {
        this.selectedQuestionNumber = value;
      }
    });
  }

  actionQuestion(isQuestionAttempted: boolean) {
    if (isQuestionAttempted) {
      this.attemptedQuestionCount += 1;
    } else {
      this.attemptedQuestionCount -= 1;
    }
    this.attemptedQuestionCount$.next(this.attemptedQuestionCount);
  }

  getQuestionList(test_id: string, candidate_id: string): Observable<QuestionResponse> {
    const url = `${environment.BASE_URL}/${environment.BASE_API.Question}` +
      `/${test_id}/candidate/${candidate_id}/test`;
    return this.http.get<QuestionResponse>(url);
  }

  navigateQuestion(questionNumber: number): void {
    this.selectedQuestionNumber$.next(questionNumber);
    this.questionRecords = this.questionRecords.map
    ((record: QuestionRecord, index: number) => {
      if(index === questionNumber) {
        record.isVisited = true;
        record.isLast = this.totalQuestions == questionNumber + 1 ? true : false;
      }
      return record;
    });
    this.temporarySelectedOption = this.questionRecords[questionNumber].selectedOption
  }

  setReviewStatus(status: boolean): void {
    this.questionRecords = this.questionRecords
    .map((record: QuestionRecord, index: number) => {
      if(index === this.selectedQuestionNumber) {
        record = {...record, isMarkedForReview: status}
      }
      return record;
    });
    this.changeQuestionRecord$.next();
  }

  answerQuestion(): void {
    this.questionRecords = this.questionRecords
    .map((record: QuestionRecord, index: number) => {
      if(index === this.selectedQuestionNumber) {
        if (!record.isAnswered) {
          this.actionQuestion(true);
        }
        record.isAnswered = true;
      }
      return record;
    });
    this.changeQuestionRecord$.next();
    this.questionRecords[this.selectedQuestionNumber]
      .selectedOption = this.temporarySelectedOption;
    if (this.questionRecords[this.selectedQuestionNumber].isLast) {
      this.utilService.endTestPopup.set(true);
    } else {
      this.navigateQuestion((this.selectedQuestionNumber + 1) % this.totalQuestions);
    }
  }

  unanswerQuestion(): void {
    this.questionRecords = this.questionRecords
    .map((record: QuestionRecord, index: number) => {
      if(index === this.selectedQuestionNumber) {
        if (record.isAnswered) {
          this.actionQuestion(false);
        }
        record.isAnswered = false;
      }
      return record;
    });
    this.changeQuestionRecord$.next();
    this.temporarySelectedOption = [];
    this.questionRecords[this.selectedQuestionNumber].selectedOption = []
  }

  decrementUnanswered(): void {
    // TODO
  }
}
